import { createStore, applyMiddleware } from "redux";
import { persistStore } from 'redux-persist';
import rootReducer from "./root-reducer";
import createSagaMiddleware from "redux-saga";
// import { onSignInStart } from './user/user.saga';

// creating sagaMiddleware by using createSagaMiddleware function which comes from "redux-saga"
const sagaMiddleware = createSagaMiddleware();

// creating an array which will have all the middleware, we have included sagaMiddleware by default
const middleWares = [sagaMiddleware];

// if we are in development mode only then we have the "logger" middleware which comes from  "redux-logger"
if (process.env.NODE_ENV === "development") {
    // middleWares.push(logger);
}

/* created our redux "store" by using createStore function which takes "root-reducer" 
     and "applyMiddleware" function as argument. which then is exported and we pass this store to 
    "Provider" component in index.js file
*/
export const store = createStore(rootReducer, applyMiddleware(...middleWares));

// run is the function which takes all the sagas as arguments and connect them with redux
// sagaMiddleware.run(onSignInStart);

/* persister is used for persisting all or selected "store's" data inside the localStorage 
    which we need even if the page gets refreshed and we pass this persister to "PersistGate"
    component in "index.js" file
 */
export const persister = persistStore(store);
